import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromBetaFeatures from './beta-features.reducer';

export const selectBetaFeaturesState = createFeatureSelector<fromBetaFeatures.BetaFeaturesState>(
  fromBetaFeatures.betaFeaturesFeatureKey
);

export const selectBetaFeaturesEnabled = createSelector(
  selectBetaFeaturesState,
  (state) => state.enabled
);
